import InputField from "@/components/InputField";
import {
  fetchSquads,
  saveSquad,
  updateLoadedSquadIndex,
} from "@/redux/squadBuilder/defaultSquadBuilder/defaultSquadBuilderSlice";
import { AppDispatch } from "@/redux/store";
import { userIsLoggedInSelector } from "@/redux/user/userSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { LoginSection } from "./LoginSection";

const squadNames = [
  "No Neymar, No Cry",
  "Unreal Madrid",
  "Pique Blinders",
  "Ctrl + Alt + De Ligt",
  "Hakuna Juan Mata",
  "Net Six and Chill",
  "Messi Business",
  "Who Ate All Depays?",
  "Backstreet Moyes",
  "Aston Vanilla",
  "Tiki-Taka Tribe",
  "Icardi B",
  "Park the Bus FC",
  "Weekend Warriors",
  "Kickball Wizards",
  "Sweaty Goals United",
  "FC Crouch Potato",
  "Kroos Control",
  "Silva Lining FC",
  "Muller's Time Machine",
  "Sons of Pitches",
  "Dybala-Rinas",
  "Top Bins United",
  "The Nutmeg Navigators",
  "Game of Throw-Ins",
  "The Dribble Squad",
  "Pjanic! At The Disco",
  "Bayern Munchies",
  "The Offsiders",
  "Header Hunters FC",
  "Keep Calm and Carrick On",
];

interface SaveSquadSectionProps {
  clickedSave: boolean;
  onClose: () => void;
  squadData: any;
}

// TODO: Remember overwrite function.

export const SaveSquadSection = ({
  clickedSave,
  onClose,
  squadData,
}: SaveSquadSectionProps) => {
  const isLoggedIn = useSelector(userIsLoggedInSelector);
  const dispatch = useDispatch<AppDispatch>();
  const [squadName, setSquadName] = useState(
    isLoggedIn ? "" : squadNames[Math.floor(Math.random() * squadNames.length)],
  );
  const [showLoginSection, setShowLoginSection] = useState(false);

  const handleSquadNameChange = (name: string) => {
    setSquadName(name);
  };

  const handleSaveSquad = async () => {
    await dispatch(saveSquad({ squadName }));
    const res = await dispatch(fetchSquads());
    dispatch(updateLoadedSquadIndex((res.payload as any[]).length - 1));
    onClose();
  };

  useEffect(() => {
    if (clickedSave) {
      if (isLoggedIn) {
        handleSaveSquad();
      } else {
        setShowLoginSection(true);
      }
    }
  }, [clickedSave]);

  return (
    <div className="flex flex-col mb-2 mt-4 text-center items-center">
      {showLoginSection ? (
        <LoginSection
          onClose={onClose}
          type="login"
          handleLoginSuccess={handleSaveSquad}
          squad={{
            ...squadData,
            name: squadName,
          }}
        />
      ) : (
        <div className="flex flex-row gap-x-2">
          <div className="w-60">
            <InputField
              placeholder="Squad Name"
              value={squadName}
              onChange={handleSquadNameChange}
              type={"default"}
            />
          </div>
        </div>
      )}
    </div>
  );
};
